<template>
    <w-card class="mb3">
        <div class="dashboard-title">JUMLAH KUTIPAN SEHINGGA HARI INI</div>
        <div class="dashboard-subtitle mt1 mb3">
            Ringkasan Kutipan Hasil Mengikut Keseluruhan
        </div>

        <table style="width: 100%" class="mb2 table-dashboard">
            <thead>
                <tr class="text-center">
                    <td class="">JENIS KUTIPAN</td>
                    <td class="" colspan="3">PENTADBIRAN TANAH</td>
                    <td class="" colspan="3">PENTADBIRAN DAERAH</td>
                    <td class=" " colspan="3">JABATAN PERHUTANAN</td>
                    <td class=" " colspan="3">PELBAGAI JABATAN</td>
                    <td class=" " colspan="3">KESELURUHAN</td>
                </tr>
            </thead>
            <tbody>
                <tr class="table-row-data">
                    <td></td>
                    <td style="background: rgba(247, 110, 17, 0.6)">
                        ANGGARAN (RM)
                    </td>
                    <td style="background: rgba(255, 159, 69, 0.6)">
                        KUTIPAN (RM)
                    </td>
                    <td style="background: rgba(166, 75, 42, 0.6)">%</td>
                    <td style="background: rgba(247, 110, 17, 0.6)">
                        ANGGARAN (RM)
                    </td>
                    <td style="background: rgba(255, 159, 69, 0.6)">
                        KUTIPAN (RM)
                    </td>
                    <td style="background: rgba(166, 75, 42, 0.6)">%</td>
                    <td style="background: rgba(247, 110, 17, 0.6)">
                        ANGGARAN (RM)
                    </td>
                    <td style="background: rgba(255, 159, 69, 0.6)">
                        KUTIPAN (RM)
                    </td>
                    <td style="background: rgba(166, 75, 42, 0.6)">%</td>
                    <td style="background: rgba(247, 110, 17, 0.6)">
                        ANGGARAN (RM)
                    </td>
                    <td style="background: rgba(255, 159, 69, 0.6)">
                        KUTIPAN (RM)
                    </td>
                    <td style="background: rgba(166, 75, 42, 0.6)">%</td>
                    <td style="background: rgba(247, 110, 17, 0.6)">
                        ANGGARAN (RM)
                    </td>
                    <td style="background: rgba(255, 159, 69, 0.6)">
                        KUTIPAN (RM)
                    </td>
                    <td style="background: rgba(166, 75, 42, 0.6)">%</td>
                </tr>
                <tr v-if="loading">
                    <td colspan="100%" class="text-center">
                        <w-spinner fade></w-spinner>
                    </td>
                </tr>
                <tr
                    v-else
                    class="table-row-data"
                    v-for="val in jenisKutipan"
                >   
                    <td class="text-bold">{{ val[0] }}</td>
                    <td style="background: rgba(247, 110, 17, 0.6)">
                        {{ val[1] }}
                    </td>
                    <td style="background: rgba(255, 159, 69, 0.6)">
                        {{ val[2] }}
                    </td>
                    <td style="background: rgba(166, 75, 42, 0.6)">
                        {{ val[3] }}
                    </td>
                    <td style="background: rgba(247, 110, 17, 0.6)">
                        {{ val[4] }}
                    </td>
                    <td style="background: rgba(255, 159, 69, 0.6)">
                        {{ val[5] }}
                    </td>
                    <td style="background: rgba(166, 75, 42, 0.6)">
                        {{ val[6] }}
                    </td>
                    <td style="background: rgba(247, 110, 17, 0.6)">
                        {{ val[7] }}
                    </td>
                    <td style="background: rgba(255, 159, 69, 0.6)">
                        {{ val[8] }}
                    </td>
                    <td style="background: rgba(166, 75, 42, 0.6)">
                        {{ val[9] }}
                    </td>
                    <td style="background: rgba(247, 110, 17, 0.6)">
                        {{ val[10] }}
                    </td>
                    <td style="background: rgba(255, 159, 69, 0.6)">
                        {{ val[11] }}
                    </td>
                    <td style="background: rgba(166, 75, 42, 0.6)">
                        {{ val[12] }}
                    </td>
                    <td style="background: rgba(247, 110, 17, 0.6)">
                        {{ val[13] }}
                    </td>
                    <td style="background: rgba(255, 159, 69, 0.6)">
                        {{ val[14] }}
                    </td>
                    <td style="background: rgba(166, 75, 42, 0.6)">
                        {{ val[15] }}
                    </td>
                </tr>
            </tbody>
        </table>
    </w-card>
</template>
<script>
export default {
    name: "JumlahKutipanSehingaHariIni",
    data() {
        return {
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            loading: false,
            jenisKutipan: [
                [
                    "HASIL CUKAI"
                ],
                [
                    "HASIL BUKAN CUKAI",
                ],
                [
                    "PELBAGAI PENERIMAAN DAN PINDAHAN",
                ],
                [
                    "JUMLAH HASIL DARI SEMUA PUNCA",
                ],  
            ],
        };
    },
    mounted() {
        this.getJenisKutipan();
    },
    methods: {
        async getJenisKutipan() {
            this.loading = true
            await axios.get(`${this.apiBaseUrl}/dashboard/kutipan-mengikut-jabatan-dan-jenis`)
            .then(e => {
                const {columns, rows} = e.data
                this.jenisKutipan = rows
            })
            this.loading = false
        },
    },
};
</script>
<style>
.dashboard-title {
    font-size: 17px;
    font-weight: bold;
    text-transform: uppercase;
}

.table-row-data {
    text-align: right;
}

path:hover,
circle:hover {
    stroke: #6666ff !important;
    stroke-width: 2px;
    stroke-linejoin: round;
    fill: #6666ff !important;
    cursor: pointer;
}
</style>
